import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { mondayOf } from "@/lib/dates";
import { SlotPicker } from "./SlotPicker";

export const CopyTaskDialog = ({ task, employees, onClose, onCopy }) => {
  const [empIds, setEmpIds] = useState([]);
  const [dates, setDates] = useState([]);

  useEffect(() => {
    setEmpIds(task?.employee_id ? [task.employee_id] : []);
    setDates([]);
  }, [task]);

  const isSource = (e, d) => e === task?.employee_id && d === task?.date;
  const count = empIds.reduce((n, e) => n + dates.filter((d) => !isSource(e, d)).length, 0);
  const confirm = async () => {
    if (await onCopy(task.id, empIds, dates)) onClose();
  };

  return (
    <Dialog open={!!task} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="copy-task-dialog" className="max-h-[92vh] overflow-y-auto rounded-2xl sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-display">Copia attività</DialogTitle>
          <DialogDescription className="truncate">{task?.title} · l'originale resta dov'è</DialogDescription>
        </DialogHeader>
        {task && <SlotPicker key={task.id} employees={employees} empIds={empIds} setEmpIds={setEmpIds} dates={dates} setDates={setDates} startMonday={mondayOf(new Date())} sourceDate={task.date} testPrefix="copy" />}
        <DialogFooter className="mt-2">
          <Button data-testid="copy-confirm-btn" disabled={count === 0} onClick={confirm} className="h-11 w-full rounded-xl sm:w-auto">
            {count > 1 ? `Crea ${count} copie` : "Crea copia"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
